export enum PivotTableCellType {
  HEADER = 'header',
  EMPTY = 'empty',
  VALUE = 'value',
  GRANDTOTAL = 'grandtotal',
  TOTAL = 'total',
}
